// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JDT6Q1z67zgHSmen0cfr{margin-left:20px;margin-right:20px}.DTRaTiT6b8YsYWZnFT1c{background:var(--border-neutral-default);width:calc(100% - 40px);height:1px;margin:16px 20px;display:flex}.rRY9VczEcQgxxwSZhvPD{justify-content:space-between;padding:8px 20px 12px;display:flex}.CgrIoOfH2bEon69KzYo5{align-items:center;gap:10px;display:flex}.CgrIoOfH2bEon69KzYo5 input{height:20px;font-size:16px}.sv0ebPhMPDgaI6rwK5LH{flex-grow:1;margin-left:16px;margin-right:12px;display:flex;position:relative}.HbpbB7RAeW8X18nlurag{justify-content:space-between;align-items:center;gap:12px;width:100%;min-width:0;display:flex}.h9VaitP2mqY4KBOrvMyU{align-items:center;gap:12px;width:calc(100% - 40px);min-width:0;display:flex}.VDYC0iBOlNUhLtmyTW_V{display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filterWrapper": `JDT6Q1z67zgHSmen0cfr`,
	"separator": `DTRaTiT6b8YsYWZnFT1c`,
	"searchWrap": `rRY9VczEcQgxxwSZhvPD`,
	"search": `CgrIoOfH2bEon69KzYo5`,
	"wrapTable": `sv0ebPhMPDgaI6rwK5LH`,
	"contactColumn": `HbpbB7RAeW8X18nlurag`,
	"contactColumnName": `h9VaitP2mqY4KBOrvMyU`,
	"messageBodyWrap": `VDYC0iBOlNUhLtmyTW_V`
};
export default ___CSS_LOADER_EXPORT___;
